import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import {
  CancelRequestTakeOverPatientFileLockInput,
  useCancelRequestTakeOverPatientMutation as useCancelRequestTakeOverPatientMutationType,
} from "@/modules/patients/services/__generated__/useCancelRequestTakeOverPatientMutation.graphql"

const cancelRequestTakeOverPatientMutation = graphql`
  mutation useCancelRequestTakeOverPatientMutation($input: CancelRequestTakeOverPatientFileLockInput!) {
    cancelRequestTakeOverPatientFileLock(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      patientFileLockOutput {
        ...PatientFileLockOutputFragment
      }
    }
  }
`

const useCancelRequestTakeOverPatientMutation = () => {
  const [commit] = useMutation<useCancelRequestTakeOverPatientMutationType>(cancelRequestTakeOverPatientMutation)

  return useCallback(
    (input: CancelRequestTakeOverPatientFileLockInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.cancelRequestTakeOverPatientFileLock
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}

export { useCancelRequestTakeOverPatientMutation }
